import React from 'react'
import LeftBar from '../../Components/LeftBar' 
import Dashnav from '../../Components/Dashnav'
import TargetAnalysisComp from './TargetAnalysisComp'

function TargetAnalysis() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <TargetAnalysisComp/>      
        </div>
    </div>
  )
}

export default TargetAnalysis